import { isCatalogInspectionChartId } from '../constants/catalogInspectionCharts';
import { isCatalogIssueChartId } from '../constants/catalogIssueCharts';
import { useInspectionChartRuntimeOptional } from './inspection/InspectionChartRuntimeContext';
import { useIssueChartRuntimeOptional } from './issue/IssueChartRuntimeContext';
import type { ChartRuntime } from 'views/analytics/types';
import type { ChartFiltersUnion } from 'shared/types/analytics';

export function useChartRuntime(
  id: string
): ChartRuntime<ChartFiltersUnion> | undefined {
  const issueRuntime = useIssueChartRuntimeOptional();
  const inspectionRuntime = useInspectionChartRuntimeOptional();

  if (isCatalogIssueChartId(id)) {
    return issueRuntime?.runtimeById[id];
  }

  if (isCatalogInspectionChartId(id)) {
    return inspectionRuntime?.runtimeById[id];
  }

  return undefined;
}
